<template lang="html">
  <div id="coverage-page">

    <section class="banner-section">
      <div class="container oversized-container">
        <div class="row align-items-center">
          <div class="col-12 col-title">
            <h5>Cobertura</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="container info-section-1">
      <div class="row justify-content-center">
        <div class="col-lg-9 col-info">
          <h5 class="txt-lg">
            <strong class="txt-purple">Skycel</strong> brinda cobertura nacional a más del <span class="txt-purple">70.70%</span> de la población a través de infraestructura propia <span class="txt-purple">4.5G</span> y el resto del país de manera compartida por medio de otras redes disponibles.
          </h5>
        </div>
      </div>
    </section>

    <section class="info-section-2">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-9 col-info">
            <p class="mb-2 text-center">
              <i class="fal fa-satellite icon"></i>
            </p>
            <h5 class="text-center txt-lg">
              Ofrecemos servicio <span class="txt-purple">4.5G para llamadas de alta calidad y la mejor experiencia de navegación</span> de forma universal, continua y no discriminatoria.
            </h5>
          </div>
        </div>

      </div>
    </section>

    <!-- <section class="info-section-3">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-info-1">
            <h3 class="mb-1 sec-title">Zona de cobertura poblacional</h3>

            <p>
              El avance de La Red Compartida ha permitido conectar a 79,414,426 de personas abarcando una Cobertura Social de 107,829 localidades dentro de las cuales se encuentran 95,749 con menos de 250 habitantes.
            </p>
          </div>

          <div class="col-12 col-maps">
            <div class="row justify-content-center">
              <div class="col-6 col-lg col-map">
                <div class="box">
                  <div class="box-icon">
                    <i class="fal fa-satellite-dish"></i>
                  </div>

                  <div class="box-info">
                    <h6 class="title">Cobertura</h6>
                    <h6 class="title pink">Actual</h6>

                    <p class="mt-3">
                      <a class="t-250 btn-map" target="_blank" href="https://www.altanredes.com/Cobertura_Actual/mapa.html">Ver Mapa</a>
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-6 col-lg col-map">
                <div class="box">
                  <div class="box-icon">
                    <i class="fal fa-map"></i>
                  </div>

                  <div class="box-info">
                    <h6 class="title">Cobertura</h6>
                    <h6 class="title pink">92%</h6>

                    <p class="mt-3">
                      <a class="t-250 btn-map" target="_blank" href="https://www.altanredes.com/Cobertura_Hito_92/mapa.html">Ver Mapa</a>
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-6 col-lg col-map">
                <div class="box">
                  <div class="box-icon">
                    <i class="fal fa-users"></i>
                  </div>

                  <div class="box-info">
                    <h6 class="title">Cobertura</h6>
                    <h6 class="title pink">Hito 50</h6>

                    <p class="mt-3">
                      <a class="t-250 btn-map" target="_blank" href="https://www.altanredes.com/Cobertura_Hito_50/mapa.html">Ver Mapa</a>
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-6 col-lg col-map">
                <div class="box">
                  <div class="box-icon">
                    <i class="fal fa-users-class"></i>
                  </div>

                  <div class="box-info">
                    <h6 class="title">Cobertura</h6>
                    <h6 class="title pink">Hito 70</h6>

                    <p class="mt-3">
                      <a class="t-250 btn-map" target="_blank" href="https://www.altanredes.com/Cobertura_Hito_70/mapa.html">Ver Mapa</a>
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-6 col-lg col-map">
                <div class="box">
                  <div class="box-icon">
                    <i class="fal fa-broadcast-tower"></i>
                  </div>

                  <div class="box-info">
                    <h6 class="title">Mapa de Cobertura</h6>
                    <h6 class="title pink">PROMTEL</h6>

                    <p class="mt-3">
                      <a class="t-250 btn-map" target="_blank" href="https://www.redcompartida.igg.unam.mx/geoportal/home">Ver Mapa</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="info-section-4">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-extra-info">
            <div class="row justify-content-center">
              <div class="col-12 my-1 my-sm-3">
                <a class="t-250 _btn" target="_blank" href="https://altanredes.com/mapas/mapa.html">
                  <i class="fal fa-satellite-dish satellite"></i><br />
                  Conoce nuestra cobertura<br />en tu zona
                </a>
              </div>

              <!-- <div class="col-sm-6 col-lg-5 my-1 my-sm-3">
                <a class="t-250 _btn gray" target="_blank" href="https://www.altanredes.com/Cobertura_Garantizada/mapa.html">Cobertura garantizada</a>
              </div>

              <div class="col-sm-6 col-lg-5 my-1 my-sm-3">
                <a class="t-250 _btn gray" target="_blank" href="https://www.altanredes.com/Cobertura_No_Garantizada/mapa.html">Cobertura no garantizada</a>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <b-modal modal-class="modal-map-s1" ref="modal-map" size="xl" centered hide-footer>
      <iframe src="https://www.altanredes.com/Cobertura_Actual/mapa.html" width="100%" height="400"></iframe>
    </b-modal> -->

  </div>
</template>

<script>
export default {
  data(){
    return{
      maps: [
        {
          icon: 'fal fa-satellite-dish',
          title: 'Actual',
          map: ''
        }
      ]
    }
  },
}
</script>
